﻿function submitForm(event) {
    event.preventDefault();
    $(event.target).parents('form').submit();
}

export function setupCarReviewSection() {
}